import React from "react";
import { useNavigate } from "react-router-dom";

function ResultCard(props: any) {
    const data = props.data;
    const navigate = useNavigate();

    function goToDetailsHandler() {
        navigate(`/product/${data.id}`, { state: { data } });
    }

    return (
        <div className="result-card" onClick={goToDetailsHandler} style={{ margin: "auto", marginBottom: "20px"}} >
            {data.parent_id === "" ? 
                <div className="result-wrap" style={{display:"flex", paddingTop:"15px"}} >
               
                    <div className="result-image" style={{width:"30%",paddingRight:"15px",margin:"auto"}}>
                        <img src={data.thumbnail} alt="product-image"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = "../img/no-img.png";
                            }}
                        />
                    </div>

                    <h2 className="variant_title" style={{width:"70%"}}>{data.title.toUpperCase()}</h2>
                    
                </div>
            : <div className="result-wrap" >
               
                    <h2 className="variant_title">{data.title.toUpperCase()}</h2>
                    {/*data.parent_id === "" ? <p className="family_desc">{data.description}</p> : <></>*/}
                    {/*<h2 className="light">{data.id}</h2>
                    <h2 className="light">{data.company}</h2>*/}
                    <div className="result-image">
                        <img src={data.thumbnail} alt="product-image"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = "../img/no-img.png";
                            }}
                        />
                    </div>
             </div>
            }
        </div>
    );
}

export default ResultCard;
